import React from 'react';
import styled from 'styled-components';
import {GridContainer} from '..';
import {SectionInnerGridContent} from './SectionInnerGridContent';
import {useBreakpointDown} from 'epic-ue-theme';

const Styled = styled.div``;

export interface GridBreakoutProps {
    children: React.ReactNode;
}

export const SectionInnerGridContentBreakout = (props: GridBreakoutProps): JSX.Element => {
    const {children} = props;
    const isSm = useBreakpointDown('sm');

    return (
        <Styled className="ue-grid-breakout">
            {isSm ? (
                <>{children}</>
            ) : (
                <GridContainer>
                    <SectionInnerGridContent>{children}</SectionInnerGridContent>
                </GridContainer>
            )}
        </Styled>
    );
};
